import React from 'react';
import { Modal, Box, Button } from '@mui/material';

import type { Colors } from '@/src/ui/styling';

interface ConfirmActionModalProps {
    open: boolean;
    title: string;
    message: React.ReactNode;
    confirmLabel?: string;
    confirmColor?: Colors;
    onConfirm: () => void;
    onClose: () => void;
}

// Generic confirmation modal — used by Force Submit / Unsubmit / Delete
// in the completion status report so they all share the same look.
const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
    open,
    title,
    message,
    confirmLabel = 'Confirm',
    confirmColor = 'warning',
    onConfirm,
    onClose,
}) => (
    <Modal open={open} onClose={onClose}>
        <Box sx={{ p: 4, bgcolor: 'background.paper', margin: 'auto', mt: 8, width: 400 }}>
            <h2 style={{ margin: 0 }}>{title}</h2>
            <div style={{ marginTop: 16 }}>{message}</div>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
                <Button variant="outlined" color="error" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="contained" color={confirmColor} onClick={onConfirm}>
                    {confirmLabel}
                </Button>
            </Box>
        </Box>
    </Modal>
);

export default ConfirmActionModal;
